import { withInstall } from '@code-monkey-ui/utils'

import Link from './src/link.vue'

export const ElLink = withInstall(Link)
export default ElLink

export * from './src/link'
